module.exports = __webpack_public_path__ + "07_mole.728e279a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer2/07_mole.png
// module id = LQ5W
// module chunks = 0